import React from 'react';

import styles from './Label.module.scss';

interface LabelProps {
    children: React.ReactNode;
}

const Label = ({ children }: LabelProps) => {
    return <div className={styles.label}>{children}</div>;
};

export default Label;
